<h2 mat-dialog-title>{{ data.title }}</h2>

<mat-dialog-content>
  <p class="text-sm mb-4">{{ data.explanation }}</p>

  <ng-container *ngIf="data.input === 'availabilityDelay'">
    <div class="section-title mb-1">Délai de disponibilité (facultatif)</div>
    <div class="flex gap-3">
      <mat-form-field appearance="outline" class="flex-auto">
        <mat-label>Valeur</mat-label>
        <input matInput type="number" min="0" step="1" [(ngModel)]="delayValue" />
      </mat-form-field>
      <mat-form-field appearance="outline" class="flex-auto">
        <mat-label>Unité</mat-label>
        <mat-select [(ngModel)]="delayUnit">
          <mat-option *ngFor="let unit of delayUnits" [value]="unit[0]">{{ unit[1] }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </ng-container>

  <mat-form-field *ngIf="data.input === 'selectedProfile'" appearance="outline" class="w-full">
    <mat-label>Profil proposé</mat-label>
    <input matInput [(ngModel)]="selectedProfile" placeholder="Ex : Technicien niveau 2" required />
  </mat-form-field>

  <div class="section-title mb-1">Appel envoyé à l'API</div>
  <div class="flex items-center gap-2 mb-2">
    <span class="method" [ngClass]="methodClass">{{ route.method }}</span>
    <code class="text-xs break-all">{{ path }}</code>
  </div>
  <pre class="code-block">{{ requestBodyText }}</pre>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" mat-dialog-close>Annuler</button>
  <button
    mat-raised-button
    type="button"
    [color]="data.danger ? 'warn' : 'primary'"
    [disabled]="!canSend()"
    (click)="send()"
  >
    Envoyer
  </button>
</mat-dialog-actions>
